// extracted by mini-css-extract-plugin
export default {"root":"Topics_root__BuVzH","filter":"Topics_filter__cQ1V4","block":"Topics_block__0vTll"};